import request from '@/lib/utils/request'
import type { ApiResponse } from '@/types'

export type NotificationTab = 1 | 2 | 3

export type NotificationBizType =
  | 'SYSTEM_MANUAL'
  | 'NEW_USER_OFFER'
  | 'CHARACTER_APPROVED'
  | 'CHARACTER_REJECTED'
  | 'NPC_LIKED'
  | 'NPC_FAVORITED'

export interface NotificationUnreadData {
  system: boolean
  personal: boolean
  interaction: boolean
}

export interface NotificationListItem {
  id: string
  tab: NotificationTab
  bizType: NotificationBizType
  title: string
  body: string | null
  hasDetail: boolean
  imageUrl: string | null
  jumpUrl: string | null
  read: boolean
  createTime: string
  actorUserId: string | null
  actorUsername: string | null
  actorAvatar: string | null
  npcId: string | null
  npcName: string | null
  npcAvatar: string | null
}

export interface NotificationListPage {
  records: NotificationListItem[]
  total: number | string
  size: number | string
  current: number | string
  pages: number | string
}

export interface NotificationDetail {
  id: string
  tab: NotificationTab
  bizType: NotificationBizType
  title: string
  detailMd: string | null
  imageUrl: string | null
  jumpUrl: string | null
  createTime: string
}

export function getNotificationUnread(signal?: AbortSignal) {
  return request<NotificationUnreadData>({
    url: '/api/notification/unread',
    method: 'get',
    signal,
    authRequired: true,
  })
}

export function getNotificationList(
  params: { tab: NotificationTab; page?: number; size?: number },
  signal?: AbortSignal,
) {
  return request<NotificationListPage>({
    url: '/api/notification/list',
    method: 'get',
    params,
    signal,
    authRequired: true,
  })
}

export function getNotificationDetail(id: string, signal?: AbortSignal) {
  return request<NotificationDetail>({
    url: `/api/notification/${id}`,
    method: 'get',
    signal,
    authRequired: true,
  })
}

export function readAllNotifications(
  tab: NotificationTab,
): Promise<ApiResponse<{ updated: number }>> {
  return request({
    url: '/api/notification/read-all',
    method: 'post',
    data: { tab },
    authRequired: true,
  })
}
